<div class="order-details-container" *ngIf="compoundDetails$ | async; let details">
    <div class="page-header-container">
      <div class="header-composed">
        <a (click)="navigateBack()" class="text-title-2 back-ref">
          {{(navigationState | navigatedFrom : 'Compounds' : '/inventory/compounds')?.name}}
        </a>
        <div class="text-title-2 header">
          {{details?.drug?.friendlyName}}
        </div>
      </div>
    
      <div class="page-subheader">
        <div class="inventory-details">
          <div class="label">NDC:</div>
          <div class="value">
            {{details?.drug?.packageNdc}}
          </div>
        </div>
        <div class="inventory-details" *ngIf="details?.lot">
          <div class="label">Lot #:</div>
          <div class="value">
            {{details?.lot}}
          </div>
        </div>
        <div class="inventory-details">
          <div class="label">EXP:</div>
          <div class="value">
            {{details?.expirationDate | formattedDate: 'MM/dd/yyyy'}}
          </div>
        </div>
        <div class="inventory-details">
          <div class="label">Performed:</div>
          <div class="value">
            {{details?.transactionDate | formattedDate: 'MM d a, HH:mm'}}
          </div>
        </div>
        <div class="inventory-details">
          <div class="label">Recorded:</div>
          <div class="value">
            {{details?.user?.firstName}}
            <ng-container *ngIf="details?.user?.lastName && details?.user?.lastName[0]">
              {{details.user.lastName[0]}}.;
            </ng-container>
            {{details?.createDate | formattedDate: 'MM d a, HH:mm'}}
          </div>
        </div>
      </div>
    </div>
    <div>
      <span class="compounded-header">Compounded</span>
      <app-generic-table
        [data]="[details]" 
        [columns]="compoundColumns"
        [withDetailsOption]="false"
      ></app-generic-table>
    </div>
    <app-tabs [tabsMarginLeft]="'32px'" class="mt-8 block mb-1">
      <app-tab 
        [tabValue]="'Ingredients'"
        [count]="ingredients?.length"
        [tabTitle]="'Ingredients'"
        [active]="currentTab === 'Ingredients'">
        <app-generic-table class="block mt-[1px]"
          [data]="ingredients" 
          [columns]="ingredientColumns"
          [withDetailsOption]="false"
          [ngStyle]="{'--table-height': 'calc(100vh - 410px)'}"
        ></app-generic-table>
      </app-tab>
      <app-tab 
        [tabValue]="'Waste'"
        [count]="waste?.length"
        [tabTitle]="'Wastes'"
        [active]="currentTab === 'Waste'">
        <app-generic-table class="block mt-[1px]"
          [data]="waste" 
          [columns]="wasteColumns"
          [withDetailsOption]="false"
          [ngStyle]="{'--table-height': 'calc(100vh - 410px)'}"
        ></app-generic-table>
      </app-tab>
    </app-tabs>
  </div>
  